import React, { PureComponent } from "react"
import PropTypes from "prop-types"

import DateHelper from "helpers/date"

import ProgressBar from "components/ProgressBar/ProgressBar"

const REFRESH_INTERVAL_SECONDS = 30

export default class ProgressBarAnimate extends PureComponent {
  static propTypes = {
    start: PropTypes.number,
    end: PropTypes.number,
    rootStyle: PropTypes.string,
    contentStyle: PropTypes.string,
  }

  static defaultProps = {
    start: 0,
    end: 0,
    rootStyle: "",
    contentStyle: "",
  }

  state = {
    progress: 0,
    displayProgress: false,
  }

  percentPerSecond = 0
  lastPercent = 0
  timer = null

  getFirstPercent = (start, end) => {
    const now = DateHelper.getCurrentTimeInSeconds()
    this.percentPerSecond = (1 / (end - start)) * 100
    return (now - start) * this.percentPerSecond
  }

  refreshPercent = () => {
    if (this.lastPercent < 100) {
      this.lastPercent = this.lastPercent + this.percentPerSecond * REFRESH_INTERVAL_SECONDS
      this.setState({ progress: Math.round(this.lastPercent) })
    } else {
      clearInterval(this.timer)
    }
  }

  constructor(props) {
    super(props)

    this.lastPercent = this.getFirstPercent(props.start, props.end)
  }

  componentDidMount = () => {
    this.timer = setInterval(this.refreshPercent, REFRESH_INTERVAL_SECONDS * 1000)
    this.displayProgressTimer = setTimeout(() => {
      this.setState({ displayProgress: true })
    }, 200)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.start !== this.props.start || prevProps.end !== this.props.end) {
      this.lastPercent = this.getFirstPercent(this.props.start, this.props.end)
      this.refreshPercent()
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.timer)
    clearTimeout(this.displayProgressTimer)
  }

  render = () => {
    const { rootStyle, contentStyle } = this.props

    const { displayProgress } = this.state

    return (
      <ProgressBar
        percent={displayProgress ? (Math.round(this.lastPercent) < 5 ? 5 : Math.round(this.lastPercent)) : 0}
        rootStyle={rootStyle}
        contentStyle={contentStyle}
      />
    )
  }
}
